import { FunctionComponent, useState, useEffect } from "react";
import { Button, TextField, Dialog, DialogActions, DialogContent, DialogTitle, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TablePagination } from '@mui/material';

import { displayValue } from "../../../helpers/TodayDate";
import { changeDateFormat } from "../../../helpers/DateFormat";

import styles from "./IstekSikayetBasvuruSorgulama.module.css";
import IstekSikayetGetAPI from "../../../apis/OB/Get/IstekSikayetGetAPI";
import IstekSikayetListeAPI from "../../../apis/OB/Get/IstekSikayetListeAPI";
import SessionStorageService from "../../../services/StorageService";

const IstekSikayetBasvuruSorgulama: FunctionComponent<any> = (props) => {
  const [basvuruNo, setBasvuruNo] = useState("");
  const [istekSikayetListe, setIstekSikayetListe] = useState<any[]>([]);
  const [istekSikayetGetListe, setIstekSikayetGetListe] = useState<any[]>([]);
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);
  const [titleContent, setTitleContent] = useState("");
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [popUpContent, setPopUpContent] = useState("");
  const [dialogOpen, setDialogOpen] = useState(false);
  const user = SessionStorageService.getUserInfo();

  // Pagination state
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(6);

  const closePopup = () => {
    setIsPopupVisible(false);
    setPopUpContent("");
    setTitleContent("");
  };

  const openPopup = () => {
    setIsPopupVisible(true);
  };

  const fetchRecords = async () => {
    try {
      const response = await IstekSikayetListeAPI.getIstekSikayetListe(user != null ? user.tcKimlikNo : props.tcKimlikNo, basvuruNo === "" ? undefined : Number(basvuruNo));
      setIstekSikayetListe(response.data);
    } catch (error) {
      console.error('Error fetching records:', error);
    }
  };

  const fetchDetailData = async (basvuruNo: any) => {
    try {
      const response = await IstekSikayetGetAPI.getIstekSikayetGetListe(basvuruNo === "" ? undefined : Number(basvuruNo));
      setIstekSikayetGetListe(response.data);
    } catch (error) {
      console.error('Error fetching detail data:', error);
    }
  };

  useEffect(() => {
    fetchRecords();
  }, []);

  const handleSearch = () => {
    fetchRecords();
  };

  const handleOpenDialog = (item: any) => {
    setSelectedIndex(item.basvuruNo);
    fetchDetailData(item.basvuruNo);
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setSelectedIndex(null);
  };

  const clearInputs = () => {
    setBasvuruNo("");
    setIstekSikayetGetListe([]);
    setIstekSikayetListe([]);
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows = rowsPerPage - Math.min(rowsPerPage, istekSikayetListe.length - page * rowsPerPage);

  return (
    <div className="d-flex align-self-strech flex-column gap-2 mt-1">
      <div className="d-flex align-self-strech flex-row justify-content-between">
        <TextField
          size="small"
          label="Başvuru No"
          variant="outlined"
          value={basvuruNo}
          onChange={(e) => setBasvuruNo(e.target.value)}
        />
        <Button onClick={handleSearch}>Ara</Button>
      </div>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Durum</TableCell>
              <TableCell>Başvuru No</TableCell>
              <TableCell>Başvuru Tarihi</TableCell>
              <TableCell>Adı</TableCell>
              <TableCell>Soyadı</TableCell>
              <TableCell>Konu</TableCell>
              <TableCell>Açıklama</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {istekSikayetListe.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((item, index) => (
              <TableRow key={index} style={item.basvuruNo === 79072 ? { display: 'none' } : {}}>
                <TableCell>
                  <Button onClick={() => handleOpenDialog(item)}>Durumu</Button>
                </TableCell>
                <TableCell>{displayValue(item.basvuruNo)}</TableCell>
                <TableCell>{displayValue(item.basvuruTarihi)}</TableCell>
                <TableCell>{displayValue(item.adi)}</TableCell>
                <TableCell>{displayValue(item.soyadi)}</TableCell>
                <TableCell>{displayValue(item.konuBasligiAdi)}</TableCell>
                <TableCell style={{ maxWidth: "500px" }}>
                  {displayValue(item.aciklama.substring(0, 240))}
                  {item.aciklama.length > 240 && (
                    <Button onClick={() => {
                      setTitleContent(`Basvuru No: ${item.basvuruNo}\nKonu: ${item.konuBasligiAdi}`);
                      setPopUpContent(`AÇIKLAMA: ${item.aciklama}`);
                      openPopup();
                    }}>Devamı</Button>
                  )}
                </TableCell>
              </TableRow>
            ))}
            {emptyRows > 0 && (
              <TableRow style={{ height: 53 * emptyRows }}>
                <TableCell colSpan={7} />
              </TableRow>
            )}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[6, 12, 24]}
          component="div"
          count={istekSikayetListe.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </TableContainer>
      <Dialog open={dialogOpen} onClose={handleCloseDialog} fullWidth maxWidth="md">
        <DialogTitle>Başvuru Detayları</DialogTitle>
        <DialogContent>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Daire</TableCell>
                  <TableCell>Sevk Tarihi</TableCell>
                  <TableCell>Sonuç Tarihi</TableCell>
                  <TableCell>Sonuç Türü</TableCell>
                  <TableCell>Açıklama</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {istekSikayetGetListe.length > 0 ? istekSikayetGetListe.map((detail, index) => (
                  <TableRow key={index}>
                    <TableCell>{displayValue(detail.daire)}</TableCell>
                    <TableCell>{displayValue(detail.sevkTarihi)}</TableCell>
                    <TableCell>{displayValue(detail.sonucTarihi)}</TableCell>
                    <TableCell>{displayValue(detail.sonucTuru)}</TableCell>
                    <TableCell>{displayValue(detail.sonucAciklamasi)}</TableCell>
                  </TableRow>
                )) : <TableRow><TableCell colSpan={5}>Kayıt Bulunamadı</TableCell></TableRow>}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">Kapat</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default IstekSikayetBasvuruSorgulama;
